import { useContext, useMemo } from 'react'
import { EventsContext } from '@BUP/contexts/EventsContext'
import { CurrentSociogramContext } from '@BUP/contexts/CurrentSociogramContext'
import { useSociogramState } from '@BUP/hooks/Sociogram/useSociogramContext'
import SociogramContentEce from './sociogram-content-ece'
import { RoleContext } from '@BUP/contexts/RoleContext'
import { ECE, TEACHER } from '@BUP/constants'
import SociogramContentTeacher from './sociogram-content-teacher'

const SociogramContentSwitcher = () => {
  const { sociogramState } = useSociogramState()
  const { dataCurrentSociogram } = useContext(CurrentSociogramContext)
  const { events = [] } = useContext(EventsContext)
  const role = useContext(RoleContext)

  const sortedEvents = useMemo(() => {
    return [...events]
      .filter(event => event.createdAt)
      .sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt))
  }, [events])

  const selectedEvent = sortedEvents[sociogramState]

  const { currentSociogram, remainingSociograms } = dataCurrentSociogram || {}

  const isDoneCurrentSociogram = currentSociogram?.isDone
  const isFirstSociogramActive = remainingSociograms === 1 && !isDoneCurrentSociogram

  return (
    <>
      {
        role.type === ECE && (
          <SociogramContentEce
            currentSociogram={currentSociogram}
            events={sortedEvents}
            selectedEvent={selectedEvent}
            sociogramState={sociogramState}
            disabled={isFirstSociogramActive}
          />
        )
      }
      {
        role.type === TEACHER && (
          <SociogramContentTeacher
            events={sortedEvents}
            selectedSociogramId={selectedEvent?.activityId}
            sociogramState={sociogramState}
            disabled={sortedEvents.length === 1}
          />
        )
      }
    </>
  )
}

export default SociogramContentSwitcher
